import React from 'react'
import { Typography, Chip, CircularProgress } from '@material-ui/core'
import { CONVERSATION_TYPE_LABELS } from '../../constants/contextEnums'

const formatDateTime = (d) => {
  if (!d) return ''
  const dt = new Date(d)
  return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
}

const truncate = (str, len) => {
  if (!str) return ''
  return str.length > len ? str.slice(0, len) + '...' : str
}

const ConversationsTab = ({ items, loading, onEdit, onRaiseQuestion }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No conversations logged.</Typography>
  }
  return items.map((conv) => (
    <div
      key={conv._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onEdit('conversation', conv)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip label={CONVERSATION_TYPE_LABELS[conv.interaction_type] || conv.interaction_type} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
        {conv.occurred_at && <span style={{ fontSize: 11, color: 'var(--ink-3)' }}>{formatDateTime(conv.occurred_at)}</span>}
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{conv.title}</div>
      {conv.contact_name && <div style={{ fontSize: 11, color: 'var(--ink-3)', marginTop: 2 }}>{conv.contact_name}</div>}
      {conv.body && <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{truncate(conv.body, 100)}</div>}
      <a
        style={{ fontSize: 11, color: 'var(--brand, #1976d2)', cursor: 'pointer', marginTop: 4, display: 'inline-block' }}
        onClick={(e) => { e.stopPropagation(); onRaiseQuestion(conv) }}
      >
        + Raise question
      </a>
    </div>
  ))
}

export default ConversationsTab
